import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-top: 15px;
`;

const SecondsCounter = ({ seconds }) => (
  <Container>
    {seconds}
  </Container>
);

export default SecondsCounter;
